export default __webpack_public_path__ + "static/media/config-exit-policy-illustration.0fcdcaef.svg";